/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIContractFile } from './APIContractFile';
import {
    APIContractFileFromJSON,
    APIContractFileFromJSONTyped,
    APIContractFileToJSON,
} from './APIContractFile';

/**
 * 
 * @export
 * @interface APIPaginatedContractFileList
 */
export interface APIPaginatedContractFileList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedContractFileList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedContractFileList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedContractFileList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIContractFile>}
     * @memberof APIPaginatedContractFileList
     */
    results: Array<APIContractFile>;
}

/**
 * Check if a given object implements the APIPaginatedContractFileList interface.
 */
export function instanceOfAPIPaginatedContractFileList(value: object): value is APIPaginatedContractFileList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedContractFileListFromJSON(json: any): APIPaginatedContractFileList {
    return APIPaginatedContractFileListFromJSONTyped(json, false);
}

export function APIPaginatedContractFileListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedContractFileList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIContractFileFromJSON)),
    };
}

export function APIPaginatedContractFileListToJSON(value?: APIPaginatedContractFileList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIContractFileToJSON)),
    };
}

